export const variantProp: any = {
  small: {
    width: "24px",
    height: "24px",
    fontSize: "12px"
  },
  regular: {
    width: "34px",
    height: "34px",
    fontSize: "14px"
  },
  large: {
    width: "44px",
    height: "44px",
    fontSize: "16px"
  }
};
